import { parse } from "date-fns";
import { YEAR_MONTH_DAY_FORMAT } from "../DateTime.constants";

export const convertStringToDateObject = ({
  dateString,
  format = YEAR_MONTH_DAY_FORMAT,
}) => parse(dateString, format, new Date());

/**
 * Converts a day interval (0-6) to the corresponding day name, where 0 is Monday.
 *
 * @param {number} interval - The day interval (0 for Monday, 1 for Tuesday, ..., 6 for Sunday).
 * @returns {string} - The name of the day (e.g., "Monday", "Tuesday").
 */
export const getDayFromInterval = (interval) => {
  const dayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  interval = parseInt(interval ?? 0);

  if (interval < 0 || interval > 6 || typeof interval !== "number") {
    return interval;
  }
  return dayNames[interval];
};
